module.exports = __webpack_public_path__ + "static/2008-layer-2-cbcbbfa58ac7bb83e69e057d3b9a596f.png";